import React from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { useBankAccountOptions, BankAccountOption } from '../../hooks/useBankAccountOptions';
import type { BankAccountAutocompleteProps } from './BankAccountAutocomplete.types';

const BankAccountAutocomplete: React.FC<BankAccountAutocompleteProps> = ({
  companyId,
  currency,
  value,
  onChange,
  error,
  helperText,
}) => {
  const { options } = useBankAccountOptions(companyId, currency, value, onChange);

  return (
    <Autocomplete
      freeSolo
      options={options}
      value={options.find((o) => o.value === value) ?? (value || null)}
      onChange={(_, val, reason) => {
        if (reason === 'clear') return onChange('');
        if (typeof val === 'string') return onChange(val.trim());
        if (val && (val as BankAccountOption).value)
          return onChange((val as BankAccountOption).value);
      }}
      onInputChange={(_, val, reason) => {
        if (reason === 'input') onChange(val);
      }}
      isOptionEqualToValue={(opt, val) =>
        typeof val === 'string' ? opt.value === val : opt.value === (val as any)?.value
      }
      getOptionLabel={(o) => (typeof o === 'string' ? o : o.label)}
      filterOptions={(x) => x}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Konto bankowe"
          placeholder="Wybierz z listy lub wpisz IBAN/numer"
          fullWidth
          error={error}
          helperText={helperText}
        />
      )}
    />
  );
};

export default BankAccountAutocomplete;
